import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n } from '@/i18n'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/Orders/OrdersView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/orders/details/:id',
    name: 'OrdersDetails',
    component: () => import('../views/Orders/OrderDetailsView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/Products/ProductsView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/products/details/:id',
    name: 'ProductsDetails',
    component: () => import('../views/Products/ProductsDetailsView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/categories',
    name: 'Categories',
    component: () => import('../views/Categories/CategoriesView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/categories/category-products/:id/:category',
    name: 'CategoryProductsView',
    component: () => import('../views/Categories/CategoryProductsView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: '/categories/sub-categories/:id/:category',
  //   name: 'SubCategories',
  //   component: () => import('../views/Categories/SubCategoriesView.vue'),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: '/categories/sub-categories/:id/:category',
  //   name: 'SubCategories',
  //   component: () => import('../views/Categories/SubCategoriesView.vue'),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/UsersView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/ProfileView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/admins',
    name: 'Admins',
    component: () => import('../views/AdminsView.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "*",
    name: 'NotFoundView',
    component: () => import('../views/NotFoundView.vue'),
    meta: {
      requiresAuth: true,
    },
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  let login = JSON.parse(localStorage.getItem('dmuser')) && localStorage.getItem('dmtoken')
  if(to.path != '/login' && to.meta.requiresAuth && !login){
    Vue.$toast.open({
      message: i18n.t("toastAlert.haveloggedIn"),
      type: 'error',
    });
    next('/login');
  } else if (to.path == '/login' && login) {
    next('/');
  } else {
    next();
  }

})


export default router
